import type { FaireProductEntity } from "../../entity_types/product";

export const p_ax6c2jy8s5: FaireProductEntity = {
  token: "p_ax6c2jy8s5",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE LT. GREY",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/045f4c0fc4cc8861d3921ab1c2a78109adf334cbd43b8af455fd9fb00706b2d6.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:58.267Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
